import { useCallback } from 'react';
import { useCartStore } from '../context/cart/CartStore';
import { shallow } from 'zustand/shallow';

const useSetNewCart = () => {
  const resetCart = useCartStore((x) => x.resetCart, shallow);

  const setNewCart = useCallback(() => {
    resetCart();
  }, [resetCart]);

  return setNewCart;
};

export default useSetNewCart;
